// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FeHO","icon":"styles_icon__3063X"};